import React, { useMemo, useState } from "react";
import { addCrewEquipment, editCrewEquipment } from "../API";
import { useParams } from "react-router-dom";
import icon1 from "../assets/images/numberSort.png";
import icon2 from "../assets/images/alphabetSort.png";
import iconAlpha from "../assets/images/alphabetSort-blue.png";
import iconNum from "../assets/images/numberSort-blue.png";
import { toast } from "react-toastify";

const AddCrewEquipment = ({
  onAddNewEquipment,
  allEquipments,
  allCrewEquipments,
}) => {
  const [selectedEquipmentRows, setSelectedEquipmentRows] = useState([]);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [hoverImage, setHoverImage] = useState(null);
  const { crewId } = useParams();

  const resetFields = () => {
    setSelectedEquipmentRows([]);
    setSortColumn(null);
    setSortOrder("asc");
    setSearchTerm("");
    setHoverImage(null);
  };

  const onAddEquipment = () => {
    if (selectedEquipmentRows?.length > 0) {
      selectedEquipmentRows?.map((ele) => {
        addNewEquipmentPromise(ele);
      });
      setSelectedEquipmentRows([]);
    } else {
      toast.warning("No equipment selected");
    }
  };

  const equipmentList = useMemo(() => {
    const filterEquipment = allEquipments
      ?.filter((equipment) => {
        const commonEquipment = allCrewEquipments.find(
          (crewEquipment) =>
            crewEquipment.equipment_id === equipment.id &&
            crewEquipment?.type === "permanent"
        );

        return commonEquipment?.equipment_id !== equipment?.id;
      })
      .map((equipment) => {
        const commonEquipment = allCrewEquipments?.find((crewEquipment) => {
          return crewEquipment.equipment_id === equipment.id;
        });
        return {
          ...equipment,
          type: commonEquipment?.type || "NA",
          crew_equipment_id: commonEquipment?.id || "NA",
        };
      });
    return filterEquipment;
  }, [allEquipments, allCrewEquipments]);

  const tableHeading = [
    {
      label: "Select",
    },
    {
      img: icon1,
      label: "Id",
      sortBy: "number",
      hoverImg: iconNum,
    },
    {
      img: icon2,
      label: "Name",
      sortBy: "name",
      hoverImg: iconAlpha,
    },
  ];

  const handleRowCheckboxChange = (row) => {
    const isSelected = selectedEquipmentRows.some(
      (selectedRow) => selectedRow.id === row.id
    );

    if (isSelected) {
      setSelectedEquipmentRows(
        selectedEquipmentRows.filter((selectedRow) => selectedRow.id !== row.id)
      );
    } else {
      setSelectedEquipmentRows([...selectedEquipmentRows, row]);
    }
  };

  const isSelected = (row) =>
    selectedEquipmentRows.some((selectedRow) => selectedRow.id === row.id);

  const handleMouseEnter = (index) => {
    setHoverImage(index);
  };
  const handleMouseLeave = (index) => {
    setHoverImage(null);
  };

  const handleSort = (column) => {
    setSortColumn(column);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const sortedUserList = [...equipmentList].sort((a, b) => {
    const valueA = sortColumn === "name" ? a.name : a.acumatica_id;
    const valueB = sortColumn === "name" ? b.name : b.acumatica_id;

    if (sortOrder === "asc") {
      return typeof valueA === "string"
        ? valueA.localeCompare(valueB)
        : valueA - valueB;
    } else {
      return typeof valueB === "string"
        ? valueB.localeCompare(valueA)
        : valueB - valueA;
    }
  });

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClick = () => {
    setSearchTerm("");
    setSelectedEquipmentRows([]);
  };

  const filteredUserList = sortedUserList.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(item.acumatica_id).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const addNewEquipmentPromise = async (data) => {
    if (data?.type !== "NA" && data?.crew_equipment_id !== "NA") {
      const payload = {
        id: data?.crew_equipment_id,
        data: {
          type: "permanent",
        },
      };
      await editCrewEquipment(payload).then((res) => {
        if (res?.status === 200) {
          resetFields();
          onAddNewEquipment();
        }
      });
    } else {
      const payload = {
        crew_id: crewId,
        equipment_id: data?.id,
      };

      await addCrewEquipment(payload).then((res) => {
        if (res?.status === 200) {
          resetFields();
          onAddNewEquipment();
        }
      });
    }
  };

  return (
    <>
      <div className="text-end">
        <button
          type="button"
          className="btn primary-btn-outlined mb-4 px-3"
          data-bs-toggle="modal"
          data-bs-target="#addEquipmentModal"
          // onClick={() => onAddCrewClick()}
        >
          + Add Equipment
        </button>
      </div>

      <div
        className="modal fade"
        id="addEquipmentModal"
        tabindex="-1"
        aria-labelledby="addEquipmentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="addEquipmentModalLabel"
              >
                Add new equipment
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClick}
              ></button>
            </div>
            <div className="modal-body">
              <>
                <div className="search-bar mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
                <div className="table-responsive">
                  <table className="table crew-modal-table table-striped">
                    <thead>
                      <tr>
                        {tableHeading?.length > 0 &&
                          tableHeading?.map((item, index, key) => (
                            <th
                              scope="col"
                              className={`table-heading col-${index}`}
                              key={key}
                            >
                              {item.label}
                              <img
                                onClick={() => handleSort(item.sortBy)}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                                src={
                                  hoverImage === index
                                    ? item.hoverImg
                                    : item.img
                                }
                                className="img-fluid icon ml-3"
                                style={{ display: index === 0 ? "none" : "" }}
                                alt=""
                              />
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUserList?.map((item, key) => {
                        return (
                          <tr key={key}>
                            <td>
                              <input
                                style={{ cursor: "pointer" }}
                                type="checkbox"
                                checked={isSelected(item)}
                                onChange={() => handleRowCheckboxChange(item)}
                              />
                            </td>
                            <td>{item.acumatica_id}</td>
                            <td>{item.name}</td>
                            <td className="details-td"></td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            </div>
            <div className="modal-footer">
              <button
                data-bs-dismiss="modal"
                type="button"
                className="primary-btn"
                aria-label="Close"
                onClick={() => onAddEquipment()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCrewEquipment;
